import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { createSelector } from 'reselect'

import { averageScore } from '../../lib'

import { selectCockpitCategory } from './selectCockpitCategory'
import { selectCockpitFinancialPlanQualitySummary } from './selectCockpitFinancialPlanQualitySummary'
import { selectCockpitInitiativesPlanQualitySummary } from './selectCockpitInitiativesPlanQualitySummary'
import { selectCockpitOffering } from './selectCockpitOffering'

export interface ICockpitCombinedPlanQualityByOffering {
  byOffering: ReadonlyMap<string, number | null>
  overallScore: number | null
}

/** Scored regardless of `IsPlanned` — see the README's Plan Quality note. */
export const selectCockpitCombinedPlanQualityByOffering = createSelector(
  [
    selectCockpitFinancialPlanQualitySummary,
    selectCockpitInitiativesPlanQualitySummary,
    selectCockpitOffering,
    selectCockpitCategory,
  ],
  (
    financialQuality,
    initiativesQuality,
    selectedOffering,
    selectedCategory
  ): ICockpitCombinedPlanQualityByOffering => {
    const byOffering = new Map(
      Array.from(financialQuality.byOffering, ([offering, quality]) => [
        offering,
        averageScore([
          quality.overall.score,
          initiativesQuality.byOffering.get(offering)?.overall.score ?? null,
        ]),
      ])
    )
    const overallScore = averageScore([
      financialQuality.overallQuality.overall.score,
      initiativesQuality.overallQuality.overall.score,
    ])

    if (selectedCategory && selectedOffering !== ProgramTypes.Overall) {
      byOffering.set(
        selectedOffering,
        averageScore([
          financialQuality.selectedQuality.overall.score,
          initiativesQuality.selectedQuality?.overall.score ?? null,
        ])
      )
    }

    return {
      byOffering,
      overallScore,
    }
  }
)
